"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUY_SUCCESS = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.buyTopup = buyTopup;

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BUY = "ms/topups/buy";
var BUY_SUCCESS = exports.BUY_SUCCESS = "ms/topups/buy_success";
var BUY_FAIL = "ms/topups/buy_fail";

var initialState = {
  buying: false,
  bought: false,
  buyError: false
};

// Reducer

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case BUY:
      return (0, _extends3.default)({}, state, {
        buying: true
      });

    case BUY_SUCCESS:
      return (0, _extends3.default)({}, state, {
        buying: false,
        bought: true
      });

    case BUY_FAIL:
      return (0, _extends3.default)({}, state, {
        buying: false,
        buyError: action.error
      });

    default:
      return state;
  }
}

// Action creators

function buyTopup(_ref) {
  var planId = _ref.planId,
      addOnId = _ref.addOnId;

  return function (_ref2) {
    var amount = _ref2.amount,
        token = _ref2.token,
        name = _ref2.name,
        company = _ref2.company,
        address1 = _ref2.address1,
        address2 = _ref2.address2,
        postalCode = _ref2.postalCode,
        country = _ref2.country,
        countryCode = _ref2.countryCode,
        city = _ref2.city,
        state = _ref2.state,
        vatNo = _ref2.vatNo,
        vatSignature = _ref2.vatSignature,
        threeDNonce = _ref2.threeDNonce,
        nonce = _ref2.nonce,
        deviceData = _ref2.deviceData;

    return function (dispatch) {
      return dispatch({
        types: [BUY, BUY_SUCCESS, BUY_FAIL],
        promise: function promise(client) {
          return client.post("v1/payments/plans/refill", {
            data: {
              planId: planId,
              addOnId: addOnId,
              amount: amount,
              paymentMethod: name && (threeDNonce || nonce) ? {
                name: name,
                company: company,
                address1: address1,
                address2: address2,
                postalCode: postalCode,
                country: country,
                countryCode: countryCode,
                vatNo: vatNo,
                vatSignature: vatSignature,
                city: city,
                state: state,
                paymentMethodNonce: threeDNonce || nonce,
                deviceData: deviceData
              } : threeDNonce ? {
                paymentMethod3DNonce: threeDNonce
              } : {
                paymentMethodToken: token
              }
            }
          }).then(function (result) {
            return { quota: result.quota };
          });
        }
      });
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/topups.js
// module id = 318
// module chunks = 0